import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    navigate('/');
    setMobileMenuOpen(false);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const navHeight = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={scrolled ? 'scrolled' : ''}>
      <div className="nav-container">
        <Link to="/" className="logo" onClick={handleLinkClick}>
          <img src="https://i.postimg.cc/fTR4YndC/Gemini-Generated-Image-ecvjxgecvjxgecvj.png" alt="RAIX Logo" className="logo-img" />
          Raix
        </Link>
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>
        <ul className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
          <li><button onClick={() => scrollToSection('features')} className="nav-link-btn">Features</button></li>
          <li><button onClick={() => scrollToSection('commands')} className="nav-link-btn">Commands</button></li>
          <li><button onClick={() => scrollToSection('about')} className="nav-link-btn">About Us</button></li>
          <li><Link to="/contact" onClick={handleLinkClick}>Contact</Link></li>
          <li>
            <a 
              className="btn-primary" 
              href="https://discord.com/oauth2/authorize?client_id=1430529243254751353" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Add to Discord
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
